import $ from 'jquery';

export const formInputValidation = form => {
    $(form)
        .parsley()
        .validate();

    const inputTypeValidation = $(form)
        .parsley()
        .isValid();

    return inputTypeValidation;
};

export const inputValidationWithId = id => {
    const selector = '#' + id;
    $(selector)
        .parsley()
        .validate();

    return $(selector)
        .parsley()
        .isValid();
};



// WEBPACK FOOTER //
// ./src/services/helper/form-helper.js